import axios from "axios";
import qs from "querystring";
import cookie from "react-cookies";

// const MAIN_URL = "https://prostogroshi.com.ua/serv/index.php";

const referer_site = "PG";

//прод токены
const url = process.env.REACT_APP_MAIN_URL;
const urlWeb = process.env.REACT_APP_SITE_REDIRECT_URL;
const createURL = `${process.env.REACT_APP_MAIN_URL}/api`;
const CreateTokin = process.env.REACT_APP_MAIN_TOKEN;

//Тест токены
// const createURL = "http://bus-pr.sgroshi.local/api";
// const url = "https://bus-pr.appgw.ftpra.com";
// const urlWeb = "https://website-pr.appgw.ftpra.com";
// const CreateTokin =
//   "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzZXJ2aWNlIjp7Im5hbWUiOiJCVVMiLCJlbnYiOiJwcm9kdWN0aW9uIn0sInV1aWQiOiI2M2VlNGZkMC05MDY4LTQwYjktYTEzNS1lNzY3YmRiOTk2NWIiLCJ1c2VyIjoiMUMtdGVzdCIsImNyZWF0ZWRfYXQiOiIyMDIxLTAyLTA1VDEyOjQ2OjU1LjA3MzcwOVoifQ.kuAAduoqiQ-GN5s-aYolkG4R3VH89ucVX9Iq7fw2W-M";

export function GetToken(partner, phone, name, amount, subpartner) {
  const requestBody = {
    partner: cookie.load("partner") ? cookie.load("partner") : "-",
    order_id: cookie.load("order_id") ? cookie.load("order_id") : "-",
    order: cookie.load("order_id") ? cookie.load("order_id") : "-",
    phone: phone ? phone : "-",
    name: name ? name : "-",
    lang: "ru",
    amount: amount ? Number(amount) : 1000,
    subpartner: cookie.load("subpartner") ? cookie.load("subpartner") : "-",
    unic_hit: cookie.load("unic_hit") ? cookie.load("unic_hit") : "-",
    referer_site: referer_site,
  };

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "Access-Control-Allow-Origin": "*",
    },
  };

  return axios.post(`${url}/api/offline/create-token`, requestBody, {});
} // запрос на токен

export function registerClientTemp(
  token,
  inn,
  last_name,
  first_name,
  second_name,
  email,
  referer,
  doc_number,
  city,
  phone,
  birth_date,
  doc_date,
  amount,
  days,
) {
  const unic = cookie.load("order_id");
  const requestBody = {
    user_id: token,
    inn: Number(inn),
    last_name: last_name,
    first_name: first_name,
    second_name: second_name,
    birth_date: birth_date.replace(/\./g, "/"),
    city: city,
    email: email,
    doc_number: doc_number,
    phone: phone,
    days: days ? days : 3,
    amount: amount ? amount : 1000,
    unic_hit: cookie.load("unic_hit") ? cookie.load("unic_hit") : "-",
    order_id: cookie.load("order_id") ? cookie.load("order_id") : "-",
    order: cookie.load("order_id") ? cookie.load("order_id") : "-",
    referer_site,
  };

  return axios.post(`${url}/api/offline/save-new-client-temp`, requestBody, {});
} // отправка ебучей инфы

export function registerNewClient(
  token,
  inn,
  last_name,
  first_name,
  second_name,
  email,
  referer,
  doc_number,
  city,
  phone,
  birth_date,
  doc_date,
  amount,
  days,
) {
  console.log("register huister");

  const unic = cookie.load("order_id");

  const requestBody = {
    user_id: token,
    inn: Number(inn),
    last_name: last_name,
    first_name: first_name,
    second_name: second_name,
    birth_date: birth_date.replace(/\./g, "/"),
    city: city,
    email: email,
    doc_number: doc_number,
    doc_date: doc_date.replace(/\./g, "/"),
    phone: phone,
    days: days ? days : 3,
    amount: amount ? amount : 1000,
    unic_hit: cookie.load("unic_hit") ? cookie.load("unic_hit") : "-",
    order_id: cookie.load("order_id") ? cookie.load("order_id") : "-",
    order: cookie.load("order_id") ? cookie.load("order_id") : "-",
    referer_site: referer_site,
    partner: cookie.load("partner") ? cookie.load("partner") : "-",
    offer: cookie.load("offer") ? cookie.load("offer") : "-",
    referer_site,
  };
  console.log(requestBody);
  return axios.post(`${url}/api/offline/register-new-client`, requestBody, {});
}

export function SmsValidete(user_id, code) {
  const requestBody = {
    user_id: user_id,
    code: code,
    referer_site: "SG",
  };
  return axios.post(`${url}/api/offline/validate-signature-sms`, requestBody, {});
} // Обработка кода смс

export function SmsReSendValidete(user_id, phone) {
  const requestBody = {
    user_id: user_id,
    phone: phone,
    referer_site: referer_site,
  };

  return axios.post(`${url}/api/offline/send-signature-sms`, requestBody, {});
} // Отправда смс на номер пользователя

export function sendPostback(finish) {
  const config = {
    headers: {
      "Content-Type": `application/json`,
      "Access-Control-Allow-Origin": "*",
      Authorization: CreateTokin,
    },
  };

  const requestBody = {
    params: cookie.loadAll(),
    offer: "PG",
    finish,
  };

  return axios.post(`${createURL}/webhook/create`, requestBody, config, {});
}

export function getRulesInfo() {
  const config = {
    headers: {
      "Content-Type": `application/json`,
      "Access-Control-Allow-Origin": "*",
      Authorization: CreateTokin,
    },
  };
  return axios.get(`${createURL}/about`, config);
}

export function sendUserInfo(userData, range, final) {
  let order_id = cookie.load("order_id");
  const requestBody = {
    // actionType: "6",
    userInfo: `${new Date().toLocaleDateString("ru-RU", {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    })};${userData.token};${order_id};${userData.inn};${userData.fio};${userData.last_name};${
      userData.second_name
    };${userData.email};'pg';${userData.doc_number};${userData.city};${userData.phone};${
      userData.birth_date
    }; ${userData.doc_date};${range.range_amount};${range.date_amount};${final}`,
  };

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };
  console.log(requestBody);
  return axios.post("https://82.192.82.84/serv/index.php", qs.stringify(requestBody), config);
}

export const sendNewPassword = (token, phone_number, code, lang) => {
  const requestBody = {
    phone_number,
    code,
    lang,
    token,
    referer_site: "PG",
    referer: "PG",
    url: "/api/send_new_password",
  };

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  return axios.post(`${url}/api/auth/send-new-password`, qs.stringify(requestBody), config);
};

export { urlWeb };



// WEBPACK FOOTER //
// src/api/main.js